import { makeStyles } from '@material-ui/core/styles'

export const useStyles = makeStyles(theme => ({
  container: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
    padding: `${theme.spacing(2.5)}px ${theme.spacing(3)}px`,
    width: '100%',
    borderRadius: '6px',
    backgroundColor: '#FFFFFF'
  },
  tableRow: {
    height: 50,
    '& > td': {
      fontFamily: 'National',
      fontSize: 15,
      letterSpacing: 0,
      lineHeight: '21px',
      border: 0,
      padding: `${theme.spacing(0.8)}px ${theme.spacing(1.5)}px ${theme.spacing(0.8)}px 0px`
    },
    '& > td:first-child': {
      paddingLeft: theme.spacing(1)
    }
  },
  headerRow: {
    height: 50,
    backgroundColor: '#F2F4F9',
    '& > th': {
      fontSize: '10px',
      fontWeight: 'bold',
      letterSpacing: '2px',
      lineHeight: '13px',
      border: 0,
      padding: `${theme.spacing(0.8)}px ${theme.spacing(1.5)}px ${theme.spacing(0.8)}px 0px`,
      textTransform: 'uppercase'
    },
    '& > th:first-child': {
      paddingLeft: theme.spacing(1)
    }
  },
  pagination: {
    display: 'flex',
    justifyContent: 'flex-end',
    width: '100%',
    borderTop: '1px solid black'
  },
  icon: {
    cursor: 'pointer'
  },
  modal: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center'
  },
  modalWrapper: {
    display: 'flex',
    flexDirection: 'row',
    backgroundColor: 'white',
    width: '95%',
    height: '95%',
    '&:focus': {
      outline: 'none'
    }
  },
  loader: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    width: '100%',
    height: '100%'
  },
  modalBody: {
    display: 'flex',
    flexDirection: 'column',
    padding: theme.spacing(5, 8),
    width: '100%'
  },
  modalHeader: {
    display: 'flex',
    justifyContent: 'space-between'
  },
  modalContent: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center'
  },
  closeModalButton: {
    boxSizing: 'border-box',
    height: '50px',
    padding: theme.spacing(2.5, 5),
    borderRadius: '3px',
    marginLeft: 'auto',
    border: '1px solid #000',
    color: '#000'
  },
  header: {
    marginBottom: 4,
    width: '100%'
  },
  tableContainer: {
    width: '100%',
    height: '100%'
  },
  modalTableContainer: {
    width: '100%',
    maxHeight: '75vh',
    overflow: 'scroll'
  }
}))
